/**
 * AnyGift バリアント変更対応スクリプト
 *
 * 【導入方法】
 * sections/main-product.liquid の {% schema %} 直前に下記を追加:
 *   <script src="{{ 'anygift-variant-fix.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var ANYGIFT_SELECTOR = '.anygift-e-gift-modal__ui';
  var savedNode = null;
  var restoreTimer = null;
  var cartBtnObserver = null;

  function isInSticky(el) {
    var cur = el.parentElement;
    while (cur) {
      var cls = cur.className || '';
      if (typeof cls === 'string' && cls.indexOf('sticky') !== -1) return true;
      cur = cur.parentElement;
    }
    return false;
  }

  function findMainBuyButtons() {
    var candidates = document.querySelectorAll('[class*="buy-buttons"]');
    for (var i = 0; i < candidates.length; i++) {
      if (!isInSticky(candidates[i])) return candidates[i];
    }
    return null;
  }

  function findMainCartButton() {
    var candidates = document.querySelectorAll('button.product-form__add-button');
    for (var i = 0; i < candidates.length; i++) {
      if (!isInSticky(candidates[i])) return candidates[i];
    }
    return null;
  }

    function syncDisabledState() {
    var anygiftBtn = document.querySelector(ANYGIFT_SELECTOR);
    if (!anygiftBtn) return;
    var cartBtn = findMainCartButton();
    var isDisabled = false;
    if (cartBtn) {
      var btnText = cartBtn.textContent.trim();
      var isSoldOut = btnText === '売り切れ' || btnText === 'Sold out';
      isDisabled = (cartBtn.disabled || cartBtn.hasAttribute('disabled')) && isSoldOut;
    }
    var innerBtn = anygiftBtn.querySelector('button') || anygiftBtn.querySelector('a') || anygiftBtn;
    if (isDisabled) {
      innerBtn.style.setProperty('background-color', 'rgb(209, 208, 207)', 'important');
      innerBtn.style.setProperty('background-image', 'none', 'important');
      anygiftBtn.style.pointerEvents = 'none';
      anygiftBtn.setAttribute('aria-disabled', 'true');
    } else {
      innerBtn.style.removeProperty('background-color');
      innerBtn.style.removeProperty('background-image');
      anygiftBtn.style.pointerEvents = '';
      anygiftBtn.removeAttribute('aria-disabled');
    }
  }

  function watchCartButton() {
    if (cartBtnObserver) cartBtnObserver.disconnect();
    var cartBtn = findMainCartButton();
    var observeTarget = null;
    if (cartBtn) {
      observeTarget = cartBtn.closest('form') || cartBtn.parentElement;
    }
    if (!observeTarget) {
      var buyBtns = findMainBuyButtons();
      if (buyBtns) observeTarget = buyBtns.parentElement;
    }
    syncDisabledState();
    if (!observeTarget) return;
    cartBtnObserver = new MutationObserver(function () {
      syncDisabledState();
    });
    cartBtnObserver.observe(observeTarget, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
  }

  function restoreButton() {
    if (!savedNode) return;
    if (document.querySelector(ANYGIFT_SELECTOR)) {
      savedNode = null;
      watchCartButton();
      return;
    }
    var mainContainer = findMainBuyButtons();
    if (!mainContainer) {
      console.warn('[AnyGift Fix] メインの buy-buttons が見つかりません');
      return;
    }
    var nodeName = (savedNode.nodeName || '').toLowerCase();
    if (nodeName === 'product-payment-container') {
      var toRemove = [];
      for (var c = 0; c < savedNode.children.length; c++) {
        var child = savedNode.children[c];
        var isAnygift = child.classList.contains('anygift-e-gift-modal__ui') ||
          (child.querySelector && child.querySelector(ANYGIFT_SELECTOR));
        if (!isAnygift) toRemove.push(child);
      }
      toRemove.forEach(function (el) { el.parentNode.removeChild(el); });
      mainContainer.appendChild(savedNode);
      console.log('[AnyGift Fix] product-payment-container を復元しました');
    } else {
      mainContainer.appendChild(savedNode);
      console.log('[AnyGift Fix] 保存したボタンを復元しました');
    }
    savedNode = null;
    watchCartButton();
    setTimeout(syncDisabledState, 1000);
    setTimeout(syncDisabledState, 2000);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var r = 0; r < m.removedNodes.length; r++) {
        var removed = m.removedNodes[r];
        if (removed.nodeType !== 1) continue;
        var hasBtn =
          (removed.classList && removed.classList.contains('anygift-e-gift-modal__ui')) ||
          (removed.querySelector && removed.querySelector(ANYGIFT_SELECTOR));
                if (hasBtn) {
          var btnInRemoved = removed.classList.contains('anygift-e-gift-modal__ui')
            ? removed
            : removed.querySelector(ANYGIFT_SELECTOR);
          savedNode = btnInRemoved.closest('product-payment-container') || btnInRemoved;

          // 保存時にスタイルをリセット（再挿入時にグレーが残らないようにする）
          var agEl = savedNode.classList && savedNode.classList.contains('anygift-e-gift-modal__ui')
            ? savedNode : savedNode.querySelector && savedNode.querySelector(ANYGIFT_SELECTOR);
          if (agEl) {
            var ib = agEl.querySelector('button') || agEl;
            ib.style.removeProperty('background-color');
            ib.style.removeProperty('background-image');
            agEl.style.pointerEvents = '';
            agEl.removeAttribute('aria-disabled');
          }

          console.log('[AnyGift Fix] ボタンの削除を検知 → 保存しました');
          clearTimeout(restoreTimer);
          restoreTimer = setTimeout(restoreButton, 800);
        }
      }
      for (var a = 0; a < m.addedNodes.length; a++) {
        var added = m.addedNodes[a];
        if (added.nodeType !== 1) continue;
        var addedHasBtn =
          (added.classList && added.classList.contains('anygift-e-gift-modal__ui')) ||
          (added.querySelector && added.querySelector(ANYGIFT_SELECTOR));
        if (addedHasBtn) {
          var btn = added.classList.contains('anygift-e-gift-modal__ui')
            ? added
            : added.querySelector(ANYGIFT_SELECTOR);
          if (btn && isInSticky(btn)) {
            clearTimeout(restoreTimer);
            restoreTimer = setTimeout(function () {
              var b = document.querySelector(ANYGIFT_SELECTOR);
              if (!b || !isInSticky(b)) return;
              var toMove = b.closest('product-payment-container') || b.parentElement;
              var main = findMainBuyButtons();
              if (main) {
                main.appendChild(toMove);
                console.log('[AnyGift Fix] スティッキーのボタンをメインフォームに移動');
              }
              watchCartButton();
            }, 200);
          }
        }
      }
    }
  });

  function init() {
    console.log('[AnyGift Fix] 初期化');
    observer.observe(document.body, { childList: true, subtree: true });
    watchCartButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();